import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import ReferralCodeItem from "./ReferralCodeItem";
import GraphQLErrors from "../../components/GraphQLErrors";
import gql from "graphql-tag";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";
import withFiltersAndSorting, {SORTING_DIRECTIONS} from "../../lib/WithFiltersAndSorting";
import PaginatorButton from "../../components/PaginatorButton";

class ReferralCodesList extends Component {

  UNSAFE_componentWillMount() {
    this.props.subscribeToReferralCodes(this.props, {}); 
  }

  render() {
    let {loading, error, referralCodes} = this.props.data;

    if (error) return <GraphQLErrors error={error} />

    // While content is loading we set data as empty array
    const data = fromJS(referralCodes || []);

    return (
      <div>
        <Table
          loading={loading}
          data={data.get("entries")}
          renderer={ReferralCodeItem}
          tableHeader={this.props.tableColumns}
          createFilteringInput={this.props.createFilteringInput}
          createSortingArrows={this.props.createSortingArrows}
          mode="table"
          onItemClick={this.handleItemClick.bind(this)}
          itemKey="code"
          showCount={true}
          selected={this.props.selectedId}
          />
        <PaginatorButton
          metadata={data.get("metadata")}
          onNext={this.handleNext.bind(this)}
          />
      </div>
    );
  }

  handleItemClick(itemData, e, field = "") {
    let id = itemData.get("code");
    this.props.onSelectionChange(id);
  }

  handleNext(afterId) {
    this.props.data.fetchMore({
      variables: {
        pagination: {
          after: afterId
        }
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return {
          promoCodes: {
            __typename: prev.referralCodes.__typename,
            metadata: fetchMoreResult.referralCodes.metadata,
            entries: [...prev.referralCodes.entries, ...fetchMoreResult.referralCodes.entries]
          }
        }
      },
    });
  }
}


const REFERRAL_CODES = gql`
  query referralCodes($filter:ReferralCodesFilterInput, $pagination:PaginationInput, $sortOrders:[SortingInput]) {
    referralCodes(filter:$filter, pagination: $pagination, sortOrders: $sortOrders) {
      entries {
        code
        description
        active
        createdAt
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`

const UPDATE_REFERRAL_CODE = gql`
  subscription updatedReferralCode {
    updatedReferralCode {
      code
    }
  }
`

const mapDispatchToProps = dispatch => ({
  subscribeToReferralCodes: (props, params) => {
    return props.data.subscribeToMore({
      document: UPDATE_REFERRAL_CODE,
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withQuery = graphql(REFERRAL_CODES, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      filter: {
        ...props.filters,
      },
      sortOrders: props.sortOrders,
    },
  })
})

export default connect(null, mapDispatchToProps)(withFiltersAndSorting(withQuery(ReferralCodesList), {
  tableColumns: (props) => [
    { title: "Code", id: "code" },
    { title: "Description", id: "description" },
    { title: "Status" },
  ],
  defaultSortings: [{name: "created_at", direction: SORTING_DIRECTIONS.DESC}],
}));